module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.b52fac2.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/font/roboto/Roboto-Bold.woff2
// module id = hKnD
// module chunks = 0